import { render, staticRenderFns } from "./CbrExamsTab.vue?vue&type=template&id=2a23cc52&scoped=true&lang=pug"
import script from "./CbrExamsTab.vue?vue&type=script&lang=js"
export * from "./CbrExamsTab.vue?vue&type=script&lang=js"
import style0 from "./CbrExamsTab.vue?vue&type=style&index=0&id=2a23cc52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a23cc52",
  null
  
)

export default component.exports